module.exports = __webpack_public_path__ + "img/mile5m-m@2.68aa6d22.jpg";